import React from 'react';

const ProjectContext = React.createContext('project');

export const ProjectContextProvider = ProjectContext.Provider;

export default ProjectContext;
